import React from "react";
import { domain } from "../../common/config";
let baseUrlInage = `//${domain}`;

class HandListSingleRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            staredHand: this.props.hand.staredHand,
        }
    }

    toggleStaredHand = () => {
        this.setState({ staredHand: !this.state.staredHand }, () => {
            this.props.setStarFlagOfHnad(this.props.hand, this.state.staredHand)
        });
    }

    render() {
        let profit = parseFloat(this.props.hand.profit)
        let profityStyle = profit >= 0 ? { color: '#6DB92C' } : { color: '#D32121' }
        let classNames = ["topWonLossCard_multireplayer", "topWonLossFlop_multireplayer", "topWonLossTurn_multireplayer", "topWonLossRiver_multireplayer"]
        let handObj = this.props.hand;
        if (!handObj.flop || handObj.flop.length === 0)
            handObj.flop = ['', '', '']
        if (!handObj.turn || handObj.turn.length === 0)
            handObj.turn = ['']
        if (!handObj.river || handObj.river.length === 0)
            handObj.river = ['']
        return (
            <tr className={`handListSingleRowWrapper ${ this.props.currentReplayerHandIndex === this.props.indexOfHand? "handListSingleRowWrapper_Active" : ""}`} style={{ boxSizing: "border-box" }} >
                {['pockeCard', 'flop', 'turn', 'river'].map((street, i) =>
                    <td key={i} className={`luckModalTd_multiReplayer ${classNames[i]} ${i === 0 ? "Padding_left_SingleRow" : ""}`}>
                        {handObj[`${street}`] && handObj[`${street}`].map((cardUrl, index) => {
                            return cardUrl === ''
                                ? <div key={index} className="luckHandCards" ></div>
                                : <img
                                    key={index}
                                    className="luckHandCardsWithCard"
                                    src={`${baseUrlInage}${cardUrl}`}
                                    role="presentation"
                                />

                        })}
                    </td>
                )}
                <td className={`luckModalTd_multiReplayer topWonLossProfit_multireplayer`} style={profityStyle}>{profit >= 0 ? '+' : '-'}{this.props.hand.gameType === 'cash' && '$'}{Math.abs(profit).toFixed(2).toString()}{this.props.hand.gameType === 'tournament' && ' BB'}</td>
                <td className={`luckModalTd_multiReplayer luckStar topWonLossStar_multireplayer`} >{this.props.showStarOption && <i onClick={this.toggleStaredHand} className={"staredHandColor " + (this.state.staredHand ? "fa fa-star" : "fa fa-star-o") + " MyHands_desktopstarPosition "} style={{ paddingRight: "16px" }}></i>}</td>
                <td className={`luckReplay luckModalTd_multiReplaye topWonLossPlay_multireplayerr`}><i style={{ fontSize: "37px", paddingTop: "2px", cursor: "pointer" }} className="hoverScale fa fa-play-circle staredHandColor Padding_right_SingleRow" onClick={() => { this.props.handReplayerOpen() }}></i></td>
            </tr>
        )
    }
}

export default HandListSingleRow;


/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/HandListSingleRow.js
 **/